import { CanvasTemplateTag } from "shared/datamodel/schemas";

const RECOMMENDED_HOME_TAG_NAME = "Home Recommended";

export function getRecommendedHomeTagOrderedByPreviewOrder(tags: CanvasTemplateTag[]) {
  return tags.find((tag) => tag.name === RECOMMENDED_HOME_TAG_NAME);
}
